<template>
  <transition name="overlay-fade">
    <div v-if="visible" class="overlay" role="status" aria-live="polite" aria-busy="true">
      <div class="glass">
        <div class="left">
          <svg class="ring" viewBox="0 0 50 50" aria-hidden>
            <circle class="ring-bg" cx="25" cy="25" r="20" />
            <circle class="ring-fg" cx="25" cy="25" r="20" />
          </svg>
        </div>
        <div class="body">
          <div class="title">{{ title || 'جارٍ المعالجة' }}</div>
          <div class="sub">{{ message || 'نرجو الانتظار قليلاً...' }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, default: '' },
    title: { type: String, default: '' }
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(6px) saturate(120%);
  background: linear-gradient(180deg, rgba(8,12,20,0.36), rgba(8,12,20,0.44));
  z-index: 9999;
  padding: 20px;
}
.glass {
  display: flex;
  gap: 18px;
  align-items: center;
  background: linear-gradient(180deg, rgba(255,255,255,0.9), rgba(248,250,252,0.86));
  border-radius: 14px;
  padding: 14px 18px;
  box-shadow: 0 12px 40px rgba(2,6,23,0.5);
  min-width: 280px;
  max-width: 520px;
  align-items: center;
}
.left { display:flex; align-items:center; justify-content:center }
.ring { width:56px; height:56px; }
.ring-bg { fill: none; stroke: rgba(15,23,42,0.08); stroke-width:4 }
.ring-fg { fill: none; stroke: #667eea; stroke-width:4; stroke-linecap:round; stroke-dasharray: 94; stroke-dashoffset: 70; transform-origin: 50% 50%; animation: spin-ring 1s linear infinite; }
.body { display:flex; flex-direction:column; gap:4px }
.title { font-weight:800; color:#0f172a; font-size:16px }
.sub { color:#475569; font-size:13px }

@keyframes spin-ring { to { transform: rotate(360deg); stroke-dashoffset: 0; } }

.overlay-fade-enter-active, .overlay-fade-leave-active { transition: opacity 220ms ease, transform 220ms ease; }
.overlay-fade-enter-from { opacity: 0; transform: translateY(-6px); }
.overlay-fade-leave-to { opacity: 0; transform: translateY(-6px); }

@media (max-width: 520px) {
  .glass { min-width: 220px; padding: 12px; gap: 12px }
  .ring { width:44px; height:44px }
  .title { font-size:15px }
}

</style>
